<template>
  <div class="cards__aside aside card_aside">
    <div
      class="aside__item card card_aside"
      v-intro="$t('HINTS.PROJECT_HINT_STEP_4')"
      v-intro-step="4"
      v-intro-if="hints('project') && $route.path.length === 4"
    >
      <Loader v-if="loading" />
      <template v-else>
        <div
          class="card__filter"
          v-for="(filter, index) in filters"
          :key="`${filter.id}_${index}`"
        >
          <h4 class="card__filter-type">
            <img src="@/assets/images/3iKXI4vqItbSTG94rMNyjK.svg" />
            <span>{{ filter.name }}</span>
          </h4>
          <div
            class="card__button Category button button_secondary"
            ref="select"
          >
            <span class="Category__name">{{ filter.value }}</span>
            <img src="@/assets/images/ryketC9SgLgfKcK0c6L4o.svg" />
            <ul class="card__list">
              <li
                class="card__list-item"
                v-for="{ id, name } in filter.list"
                :key="id"
                @click="
                  (filter.value = name),
                    defineFilterId({ name: filter.name, id }),
                    fetchCards({
                      API: $route.meta.API,
                      page: currentPage || $route.query.page
                    }),
                    $router
                      .push(`${$route.meta.description.to}?page=1`)
                      .catch(e => e)
                "
              >
                {{ name }}
              </li>
            </ul>
          </div>
        </div>

        <div class="card__reset">
          <div
            class="card__button button button_secondary"
            @click="resetAllFilters()"
          >
            <span>{{ $t("RESET") }}</span>
          </div>
        </div>
        <div class="card__add-request">
          <div
            class="card__button button button_primary"
            @click="
              managePopupState({ popup: 'requestHelpForm', _state: true })
            "
          >
            <span>{{ $t("ADD_REQUEST") }}</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "Aside",
  props: { fetch: { type: String, required: true } },
  data: () => ({
    loading: true
  }),
  computed: mapGetters(["currentPage", "filters", "hints"]),
  methods: {
    ...mapActions(["fetchCards", "fetchFiltersList"]),
    ...mapMutations(["defineFilterId", "resetFilters", "managePopupState"]),
    async resetAllFilters() {
      this.resetFilters();
      this.filters.map(filter => (filter.value = filter.default));
      this.$router
        .push(`${this.$route.meta.description.to}?page=1`)
        .catch(e => e);
      await this.fetchCards({
        API: this.$route.meta.API,
        page: this.$route.query.page
      });
    },
    manageSelect({ target }) {
      this.$refs.select.forEach(select => {
        target === select
          ? select.classList.toggle("expanded")
          : target !== select &&
            select.classList.contains("expanded") &&
            select.classList.remove("expanded");
      });
    }
  },
  async mounted() {
    this.fetchFiltersList({
      locale: `${this.$route.path.slice(0, 4)}/${localStorage
        .getItem("curLang")
        ?.toLowerCase() || "ru"}`,
      url: this.fetch
    }).then(() => (this.loading = false));

    document.addEventListener("click", this.manageSelect);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.manageSelect);
  }
};
</script>

<style lang="scss">
@import "@/assets/_vars";

/*<aside>*/
.aside {
  &__item {
    margin: 0 0 50px;
  }

  .Category {
    &__name,
    img {
      pointer-events: none;
    }
  }

  @media screen and (min-width: $min-md) {
    &__item {
      position: sticky;
      top: 30px;
    }
  }
}

.card.card_aside {
  .card {
    &__filter-type {
      align-items: center;

      span {
        margin: 0 0 0 10px;
        font-weight: $b_fw;
        line-height: normal;
      }

      label {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
      }
    }

    &__button-wrap {
      display: inherit;
    }

    &__button {
      position: relative;
      justify-content: space-between;
      padding: 10px 20px;
      margin: 10px 0 0;
      -webkit-tap-highlight-color: transparent;

      input {
        font-weight: $b_fw;
        color: rgba($prim_c, 0.8);
        pointer-events: none;
        background-color: transparent;
        border: none;
        outline: none;
      }

      img {
        transition: transform 0.2s;
        transform: rotate(90deg);
      }

      &.expanded {
        background-color: darken($sec_bg, 5%);
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;

        .card__list {
          display: block;
        }
      }
    }

    &__list {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 100;
      display: none;
      width: 100%;
      max-height: 250px;
      overflow-y: scroll;
      border-bottom-right-radius: 10px;
      border-bottom-left-radius: 10px;

      &-item {
        padding: 10px 20px;
        background-color: darken($sec_bg, 5%);

        &:hover {
          background-color: darken($sec_bg, 7.5%);
        }
      }

      &-link {
        display: block;
        color: $prim_c;
      }

      &::-webkit-scrollbar {
        width: 0.1px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgba(#000, 0.1);
      }
    }

    &__filter + .card__filter {
      margin: 25px 0 0;
    }

    &__done {
      .card__button {
        &:hover {
          background-color: darken($aux_bg, 5%);
        }
      }
    }

    &__reset,
    &__add-request,
    &__done {
      justify-content: center;
      margin: 20px 0 0;
    }

    &__filter,
    &__reset {
      .button_primary {
        &:hover {
          background-color: darken($aux_bg, 5%);

          img {
            transform: rotate(0deg);
          }
        }
      }
      .button__secondary {
        &:hover {
          background-color: darken($sec_bg, 5%);

          img {
            transform: rotate(0deg);
          }
        }
      }
    }

    &__filter-type,
    &__reset,
    &__add-request,
    &__done {
      display: flex;
    }
  }
}
</style>
